import React, { lazy }		from 'react';
import PermissionService	from '@Services/PermissionService';
const Clients = lazy(() => import('./components/Clients'));

export const clientsConfig = [
	{
		auth: true,
		component: <Clients/>,
		pm: (pm) => PermissionService(pm).getClientsList(),
		name: 'clients',
		path: '/clients',
	},
]